import React, { FC, useMemo } from 'react';
import { Button, Input } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

type Props = {
  value?: string[];
  onChange?: (value: string[]) => void;
};

export const StringListInput: FC<Props> = (props) => {
  const { onChange, value } = props;
  const { t } = useTranslation();
  const val: any[] = useMemo(() => {
    const v: any[] = [...(value ?? [])];
    if (v.length === 0 || (v[v.length - 1] ?? '').trim() !== '') {
      v.push(undefined);
    }
    return v;
  }, [value]);
  return (
    <div className="flex flex-col w-full gap-2">
      {val.map((item: any, index: number) => (
        <div key={index} className="w-full flex gap-2">
          <Input
            placeholder={t('shiftTemplate.addTask')}
            value={item}
            onChange={(e) => {
              const vx = val.map((v, i) => (index === i ? e.target.value : v));
              onChange?.(
                (vx[vx.length - 1] ?? '').trim() !== ''
                  ? vx
                  : vx.slice(0, vx.length - 1),
              );
            }}
          />
          {index !== val.length - 1 && (
            <Button
              danger={true}
              onClick={() => onChange?.(val.filter((v, i) => i !== index))}
            >
              <DeleteOutlined />
            </Button>
          )}
        </div>
      ))}
    </div>
  );
};
